import { render, staticRenderFns } from "./post-notice-add.vue?vue&type=template&id=f4f5b2ea"
import script from "./post-notice-add.vue?vue&type=script&lang=ts"
export * from "./post-notice-add.vue?vue&type=script&lang=ts"
import style0 from "./post-notice-add.vue?vue&type=style&index=0&id=f4f5b2ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports